import React from 'react';
import {Icon, symbolUrl} from '../../common';

export default function ConversionHeader({closeModal}) {
    return (
        <section className="pane pane--white py-3 py-lg-7">
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-auto">
                        <button
                            className="btn btn-link text-base d-flex align-items-center p-0"
                            type="button"
                            onClick={closeModal}>
                            <Icon url={symbolUrl('arrow')} size="24" classes="icon--reversed" />
                            <span className="btn__text font-weight-medium">Terug naar voertuig</span>
                        </button>
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn btn-link text-base p-0"
                            type="button"
                            onClick={closeModal}>
                            <Icon url={symbolUrl('cross')} size="16" />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}
